<template lang="pug">
  component(:is="layout" data-testid="notifications-page")
    CommonSection(title="Уведомления")
      FormBlock(mobile)
        NotificationList
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import SupplierLayout from '@/layouts/Supplier.vue';
import CommonSection from '@/components/CommonSection.vue';
import NotificationList from '@/components/notification/NotificationList.vue';
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'NotificationsPage',
  components: {
    FormBlock,
    DefaultLayout,
    SupplierLayout,
    CommonSection,
    NotificationList,
  },
  computed: {
    /**
     * (Claude) Поставщику страница показывается в оболочке кабинета: остального интерфейса TeRoom он
     * не видит, а «Уведомления» — пункт меню кабинета (ТЗ 6.1). Признак поставщика — карточка
     * поставщика в ответе о текущем пользователе (ТЗ 3.4, 12.3).
     */
    layout() {
      return this.$store.state.auth.user?.supplier ? 'SupplierLayout' : 'DefaultLayout';
    },
  },
  created() {
    // (Claude) обычно уведомления подгружает колокольчик в шапке приложения, но в оболочке кабинета
    // поставщика шапки приложения нет — список запрашивает сама страница (повторный вызов действия
    // ничего не делает: опрос заводится один раз)
    this.$store.dispatch('notification/fetch');
  },
};
</script>
